module.exports = __webpack_public_path__ + "img/product_101.68bac39.webp";